// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__21e7z","imageUploader":"EGiftCard_imageUploader__u63j_"};